import moment from "moment";

import { useIsViewOnlyUser } from "manager/hooks/useIsViewOnlyUser";
import { useVeroFlag } from "shared/utils/featureFlags";
import { VeroFlag } from "shared/utils/veroFlags";

/**
 * PRODUCT-1772: Legal Audit (View Only) document redaction.
 * Requires both a "view only" role and the GrowthBook flag.
 */
export const useLegalAuditDocumentRedaction = () => {
  const { isViewOnly, isLoading } = useIsViewOnlyUser();
  const flagEnabled = useVeroFlag(
    VeroFlag.legalAuditDocumentRedactionProduct1772
  );

  return {
    // Fail closed while profile loads when the flag is on, so docs/DOB/PDF
    // do not briefly render before isViewOnly resolves.
    shouldRedactDocuments: flagEnabled && (isLoading || isViewOnly),
    isLoading,
  };
};

/** DOB as Month/Year when legal-audit redaction is active. */
export const formatLegalAuditDob = (date: string | Date | undefined | null) =>
  date ? moment(date).format("MM/YYYY") : "N/A";

export default useLegalAuditDocumentRedaction;
